import React from "react";
import SideBar from "./SideBar";
import { useNavigate } from "react-router-dom";
import blendLogo from "../../assets/images/blendLogo.png";
import './Header.css'


const styles = {
  header: `sticky top-0 z-50 grid grid-cols-2 bg-white shadow-md py-2 px-5 md:px-10`,
  navWrapper: `hidden lg:flex justify-end items-center z-20`,
  imgContainer: `flex items-center sm:ml-[9%] z-10`,
  linkPTag: `text-gray-500 hover:text-gray-900 cursor-pointer font-semibold uppercase text-sm hover:-translate-y-1 transition ease-in-out duration-300`,
};

const Header = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.header}>
      <div className={styles.imgContainer}>
        <img
          src={blendLogo}
          alt="Blend IT Logo"
          className="w-20 h-10 sm:w-28 sm:h-12"
          onClick={() => navigate("/")}
        />
      </div>

      {/* For Mobile view */}
      <nav className="flex lg:hidden">
        <SideBar />
      </nav>

      {/* For laptop and desktop view */}
      <nav className={styles.navWrapper}>
        <ul className="flex items-center">
          <li>
            <p className={styles.linkPTag}>solutions</p>
          </li>
          <li>
            <p className={styles.linkPTag}>about</p>
          </li>
          <li>
            <p 
              className={styles.linkPTag}
              onClick={() => navigate("/services")}
            >
              services
            </p>
          </li>
          <li>
            <p 
              className={styles.linkPTag}
              onClick={() => navigate("/work")}
            >
              work
            </p>
          </li>
          <li>
            <p className={styles.linkPTag}>news</p>
          </li>
          <li>
            <p className={styles.linkPTag}>contact</p>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Header;
